import { useEffect, useState, useTransition } from "react";


import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getEmployes } from "../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import  SingleEmploy from "../singleemploy";
import SubFilterEmployes from "../subfilterEmployes";


import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";
import classes from "./employDataTable.module.css";

const EmployDataTable = () => {
 
  const [currentPage, setcurrentPage] = useState(1);
  const [name ,setName]=useState("")
  const [sb_branch_id, setSbBranchId] = useState("")
  const [sb_department_id ,setSbDepartmentId] = useState("")
  const [sb_nationality_id ,setSbNationalityId]=useState("")
  const [active , setActive]=useState("")
  const {i18n}= useTranslation()
  const lang = i18n.language
  const { data, isLoading, refetch,error } = useQuery(
    ["getEmploy", currentPage ,name ,sb_department_id ,sb_branch_id ,sb_nationality_id ,active ,lang],
    () => getEmployes(currentPage,name ,sb_department_id ,sb_branch_id ,sb_nationality_id ,active,lang)
  );


  useEffect(() => {
    refetch();
  }, [refetch,  currentPage]);


  const totalItems = data?.total;
  const itemsPerPage = data?.last_page;
  const employes = data?.data || [];
  const responeMessage= data?.message


  if(error){  
    return <ErrorMessage  error={error}/>
  }

 
  return (
    <div className="container-fluid">  
        <SubFilterEmployes 
          branchId={sb_branch_id}
          setName={setName}
          setSbBranchId={setSbBranchId}
          setSbDepartmentId={setSbDepartmentId}
          setSbNationalityId={setSbNationalityId}
          setActive={setActive}
        />
      <div className="row">
      { isLoading ?<LoadingSpinner/>   :
      <>

      {employes.length===0 ? <NoData  responeMessage={responeMessage}/> : <>   {!data ? <div>no data available </div>:
        <>
        {employes.map((employ) => (
          <SingleEmploy  
            key={employ.id}
            employ={employ}
            classes={classes}
            refetch={refetch}
          />
        ))}
        </>}</>  
     
        }
      </>
   
        }
      </div>
      <div className="d-flex justify-content-center">
          <PagnationComponent
            currentPage={currentPage}
            setCurrentPage={setcurrentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
    </div>
  );
};

export default EmployDataTable;
